import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CreateConfiguration,
  type ICreateConfigurationData,
  OrganisationService,
} from '@principle-theorem/ng-principle-shared';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  ServiceCodeGroup,
  TreatmentConfiguration,
} from '@principle-theorem/principle-core';
import {
  ServiceCodeGroupType,
  type ITreatmentConfiguration,
} from '@principle-theorem/principle-core/interfaces';
import {
  type DocumentReference,
  Region,
  snapshot,
} from '@principle-theorem/shared';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ITreatmentFormData extends Pick<ITreatmentConfiguration, 'name'> {}

@Component({
  selector: 'pr-create-treatment-configuration',
  templateUrl: './create-treatment-configuration.component.html',
  styleUrls: ['./create-treatment-configuration.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateTreatmentConfigurationComponent extends CreateConfiguration<
  CreateTreatmentConfigurationComponent,
  ITreatmentFormData,
  ITreatmentConfiguration
> {
  form: TypedFormGroup<ITreatmentFormData> =
    new TypedFormGroup<ITreatmentFormData>({
      name: new TypedFormControl('', Validators.required),
    });

  constructor(
    dialogRef: MatDialogRef<
      CreateTreatmentConfigurationComponent,
      DocumentReference<ITreatmentConfiguration>
    >,
    @Inject(MAT_DIALOG_DATA)
    data: ICreateConfigurationData<ITreatmentConfiguration>,
    private _organisation: OrganisationService
  ) {
    super(dialogRef, data);
  }

  protected async _transformData(
    formData: ITreatmentFormData
  ): Promise<ITreatmentConfiguration> {
    const region = await snapshot(this._organisation.region$);
    return TreatmentConfiguration.init({
      ...formData,
      serviceCodeGroups:
        region === Region.NewZealand
          ? []
          : [ServiceCodeGroup.init({ type: ServiceCodeGroupType.Required })],
    });
  }
}
